import React from "react";
import { motion } from "framer-motion";

const WhyChooseUs = () => {
  const cards = [
    { icon: "🎈", title: "Fun & Engaging", text: "Interactive lessons, games, and projects keep learners excited." },
    { icon: "🎓", title: "Expert Tutors", text: "Patient, trained instructors for kids, teens, and adults." },
    { icon: "🕒", title: "Flexible Options", text: "Online & physical classes , weekday or weekend schedules." },
    { icon: "🚀", title: "From Basics to Advanced", text: "Support for beginners to competition-level learners." },
  ];

  return (
    <section id="why" className="py-20 bg-gradient-to-b from-white to-indigo-50">
      <div className="max-w-7xl mx-auto px-6">
        <motion.h2 initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="text-3xl md:text-4xl font-extrabold text-indigo-900">
          Why Families Choose Us
        </motion.h2>

        <div className="mt-10 grid md:grid-cols-4 gap-6">
          {cards.map((c) => (
            <motion.div
              key={c.title}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="p-6 rounded-2xl border bg-white hover:shadow-lg transition"
            >
              <div className="text-3xl">{c.icon}</div>
              <h3 className="mt-3 font-semibold text-indigo-900">{c.title}</h3>
              <p className="text-gray-600 text-sm mt-1">{c.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
